module.exports = __webpack_public_path__ + "img/view-active.abb3353e.png";